import { fileUrl } from 'api/api'
import TreatmentHistoryApi from 'api/dentists/treatment-history.api'
import ClinicApi from 'api/master/clinic.api'

export const exportSSO = async () => {
  try {
    const SHARED_CONTAINER = 'shared'
    const ssoPath = '/templates/sso/pdf-sso.pdf'
    const token = await ClinicApi.generateSasToken(ssoPath, 300, SHARED_CONTAINER)
    const storageBase = fileUrl.replace(/\/[^/]+$/, '')
    const fileWithToken = `${storageBase}/${SHARED_CONTAINER}${ssoPath}?${token.data}`
    window.open(fileWithToken, '_blank')
  } catch (error) {
    console.error('Failed to export SSO:', error)
  }
}

export const exportOPDCover = async (patientId: number) => {
  const print = await TreatmentHistoryApi.printOPDCover(patientId)
  if (print?.status === 200) {
    window.open(`${fileUrl}/${print.data}`, '_blank')
    return true
  } else {
    return false
  }
}

export const exportOPD = async (patientId: number) => {
  const print = await TreatmentHistoryApi.printOPD(patientId)
  if (print?.status === 200) {
    window.open(`${fileUrl}/${print.data}`, '_blank')
    return true
  } else {
    return false
  }
}


export const exportOPDEmpty = async (patientId: number, props?: { type: '0' | '1' }) => {
  const print = await TreatmentHistoryApi.printOPDEmpty(patientId, props)
  if (print?.status === 200) {
    window.open(`${fileUrl}/${print.data}`, '_blank')
    return true
  } else {
    return false
  }
}
export const exportOPDV1 = async (patientId: number, lang: string) => {
  const print = await TreatmentHistoryApi.printOPDV1(patientId, { lang })
  if (print?.status === 200) {
    window.open(`${fileUrl}/${print.data}`, '_blank')
    return true
  } else {
    return false
  }
}


export const exportOPDAppointment = async (appointmentId: number, lang: string) => {
  const print = await TreatmentHistoryApi.printOPDAppointment(appointmentId, { lang })
  if (print?.status === 200) {
    window.open(`${fileUrl}/${print.data}`, '_blank')
    return true
  } else {
    return false
  }
}